import { COLORS } from '@constants';
import { Card } from 'antd';
import styled, { css } from 'styled-components';

export const StyledCard = styled(Card)`
    ${({ $hover }) =>
        $hover &&
        css`
            &:hover {
                outline: 2px solid ${COLORS.$pink};
                outline-offset: -1px;
                cursor: pointer;
            }
        `};

    ${({ $isActive }) =>
        $isActive &&
        css`
            outline: 2px solid ${COLORS.$pink};
            outline-offset: -1px;
            cursor: pointer;
        `};

    ${({ $edit }) =>
        $edit &&
        css`
            background-color: ${COLORS.$gray15Black};
        `};

    ${({ $disabled }) =>
        $disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
            filter: grayscale(100%);
        `};
`;
